import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, limit: number = 50): string {
    if (!value) return '';
    const regex = new RegExp(`(.{1,${limit}})`, 'g');
    return value.match(regex)?.join('\n') || value;
  }

}
